export default {
  message: {
    accountSessionTitle: 'Sign-in status updated',
    loginSessionUnavailable: 'Unable to establish a valid session. Account details may be incomplete or cookies unavailable. Please sign in again.',
    accountSession_checking: 'Checking meeting permissions for the current account.',
    accountSession_anonymous: 'Your session has expired. Returning to sign-in.',
    sessionLoginSuccess: 'Signed in successfully',
    sessionLoginReturnHint: 'Your session has been updated. Open your meeting invitation to join.',
    accountSession_denied: 'The current account has not passed the meeting access check. Previous account actions are paused.',
    accountSession_error: 'Unable to check account permissions. Please retry.',
    accountSession_changed: 'Access has been checked, but the account cannot be matched to the connected meeting identity. Leave and rejoin to use the new identity.',
    accountSessionConnection: 'A sign-in change will not automatically disconnect the meeting. Actions are paused until identity is verified.',
    accountSessionRetry: 'Check again',
    accountSessionLogin: 'Sign in again',
    microphoneChanging: 'Processing...',
    microphoneSwitchRestored: 'Could not switch microphones. Your previous microphone has been restored.',
    microphoneRestoreFailed: 'Could not switch or restore your microphone. Select a device and turn your microphone on again.',
    microphoneSwitchPending: 'The device change is still pending. Your microphone is paused while we wait to restore the previous device. Rejoin the meeting if this persists.',
    remoteAudioFailedTitle: 'Some meeting audio could not be restored',
    remoteAudioFailed: 'Audio reconnection was unsuccessful. Click Restore Audio to retry. If the issue persists, check your network or rejoin the meeting.',
    audioGestureTitle: 'Enable meeting audio',
    audioGestureHint: 'Your browser blocked automatic audio playback. Click Enable Audio to continue listening.',
    microphoneFailed: 'Microphone operation failed. Check your device and permissions, then try again.',
    screenStarting: 'Starting screen share...',
    screenStopping: 'Stopping screen share...',
    screenShareFailed: 'Screen sharing could not be completed. Check your selection and browser permissions, then try again.',
    joinMeeting: 'Join Meeting',
    phonePlaceHolder: 'Please enter mobile phone number',
    emailPlaceHolder: 'Please enter email',
    within: 'within',
    overseas: 'Overseas',
    codePlaceHolder: 'Please enter the verification code',
    imageCodePlaceHolder: 'Please enter the image verification code',
    imageCodeAlt: 'Image verification code',
    getCode: 'get code',
    getImageCode: 'Get image code',
    getting: 'Getting...',
    getImageCodeFirst: 'Please get the image verification code first',
    imageCodeFail: 'Failed to get image verification code',
    getEmailCode: 'Send verification code email',
    rightPhone: 'Please enter a valid mobile phone number',
    rightEmail: 'Please enter a valid email address',
    join: "JOIN",
    codeSuccess: 'Verification code sent successfully',
    codeFail: 'Sending failed, please try again later',
    wait: 'Waiting for the host to start the meeting',
    time: 'There is still time before the meeting begins',
    introduce: 'Introduce',
    expert: 'Expert',
    expertPhone: 'Expert-Phone',
    guest: 'Guest',
    host: 'Host',
    audience: 'Audience',
    saySomething: 'Say something',
    handsUpSuccess: 'you successfully raise your hand, you can tell the host what you want to say through the chat box.',
    logout: 'Are you sure you want to log out?',
    leave: 'Are you sure you want to leave the meeting?',
    set: 'Set Up',
    setMic: 'Set up the microphone',
    errorMic: 'Please grant microphone access first',
    errorCamera: 'Please grant camera permissions first',
    loading: 'Joining, please wait',
    end: 'Thank you for attending the meeting',
    meetingRescheduledEnd: 'Due to circumstances involving the expert, this meeting needs to be rescheduled. We apologize for the inconvenience.',
    textBD: 'Please contact your BD',
    error1: 'Sorry, the address you requested does not exist',
    error2: 'Sorry, your meeting ID is incorrect',
    error3: 'Sorry, you do not have meeting privileges',
    error4: 'Sorry, the meeting you attended has ended',
    error5: 'Sorry, the meeting room you\'re joining is in use. Please contact the administrator.',
    error6: 'Sorry, the system doesn\'t support the WeChat browser for now. Please use Chrome/Safari instead.',
    wechatBrowserTitle: 'Open in your default browser',
    copyingMeetingLink: 'Copying meeting link...',
    meetingLinkCopied: 'Meeting link copied. Paste it into your default browser to continue.',
    meetingLinkCopyFallback: 'Unable to copy automatically. Press and hold or select the link below to copy it, then paste it into your default browser.',
    meetingLinkMissingTitle: 'Reopen the meeting invitation link',
    meetingLinkMissingHint: 'This address does not contain meeting details. Find the original invitation link in your WeChat chat or email and open it in your default browser.',
    wechatBrowserHint: 'Tap the menu in the top-right corner and select "Open in browser".',
    weeklyActivityNotStarted: "This week's meeting has ended.",
    audienceCount: 'Audience Count',
    notFound: 'No such account found. Please contact the BD team to pre-register an account.',
    joining: 'Joining Meeting',
    loadingMeetingInfo: 'Loading meeting details',
    meetingTime: 'Meeting Time',
    enterMeetingRoom: 'Enter Meeting Room',
    meetingStatus: 'Meeting Status',
    meetingStatusRegistering: 'Registration Open',
    meetingStatusEnded: 'Ended',
    meetingStatusPendingStart: 'Not Started',
    restartingMeeting: 'Restarting meeting...',
    restartMeetingConfirm: 'Restart this meeting? Its status will be reset to Not Started, and you can enter the meeting room again.',
    restartMeetingSuccess: 'Meeting restarted. Refreshing meeting details...',
    restartMeetingFailed: 'Failed to restart the meeting. Please try again later.',
    restartMeetingInfoMissing: 'A valid meeting ID is unavailable. Please refresh and try again.',
    restartMeetingLoginRequired: 'Your session has expired. Please sign in again to restart the meeting.',
    meetingStatusInProgress: 'In Progress',
    meetingStatusRegistered: 'Registered',
    meetingStatusRescheduled: 'Rescheduled - Pending',
    meetingStatusUnknown: 'Unknown Status',
    leaveMsg: 'Before leaving the virtual meeting, please transfer the host privileges to the meeting assistant.',
    emptyLeaveMsg: 'Host privileges will be transferred to an attendee 5 minutes after you leave. If you do not plan to continue the meeting, please end the meeting instead.',
    shareScreen: 'Check Share System Audio below to share computer sound while sharing your screen.',
    shareScreen1: 'Share successful. Please confirm audio sharing status!',
    changeVideo: 'All audience members will see you once the camera is turned on. Please confirm whether you want to enable it.',
    loginElsewhere: 'Your phone number has been logged in elsewhere. Please rejoin the meeting.',
    welcome: 'Welcome to the JQ Forum Meeting',
    recordingRequiredTitle: 'Cloud Recording Not Started',
    recordingStartFailed: 'Cloud recording failed to start. The meeting cannot continue without recording. Check your network and try again.',
    recordingRequiredBeforeStart: 'Cloud recording has not started, so the meeting cannot begin yet. The system is retrying.',
    turnOnCamera: "Turn On Camera",
    turnOffCamera: "Turn Off Camera",
    startMeeting: "Start Meeting",
    endingMeeting: "Ending Meeting...",
    endMeetingFailed: "Failed to end the meeting. Check your network and try again.",
    reschedulingMeeting: "Rescheduling...",
    rescheduleMeetingTitle: "Confirm Rescheduling",
    rescheduleMeetingConfirm: "Does this meeting need to be rescheduled? The current meeting will end and customers will receive a rescheduling notification after you confirm.",
    rescheduleMeetingSuccess: "The meeting has been rescheduled. Customers will receive a notification.",
    rescheduleMeetingFailed: "Failed to reschedule the meeting. Please try again later.",
    rescheduleMeetingInfoMissing: "Current meeting information is unavailable. Please refresh and try again.",
    feedbackTitle: "Activity Feedback",
    expertScore: "Qualitative Score",
    quantitativeScore: "Quantitative Score",
    canLongTermCooperate: "Can Cooperate Long Term",
    canLongTermCooperateYes: "Yes",
    canLongTermCooperateNo: "No",
    isCreateTranscript: "Generate Meeting Minutes",
    createTranscriptYes: "Create",
    createTranscriptNo: "Do Not Create",
    createTranscriptRequired: "Please select whether to generate meeting minutes",
    qualitativeScoreRequired: "Please select a 1-4 star qualitative score",
    quantitativeScoreRequired: "Please select a 1-4 star quantitative score",
    longTermCooperateRequired: "Please select whether long-term cooperation is possible",
    feedbackEvaluationRequired: "Please enter your evaluation for this expert",
    feedbackEvaluationLimit: "Evaluation cannot exceed 512 characters",
    expertEvaluationPlaceholder: "Please enter your evaluation for this expert",
    feedbackSuccess: "Feedback submitted successfully",
    feedbackFailed: "Failed to submit feedback. Please try again later",
    feedbackLeaveWarning: "Your feedback has not been submitted. Are you sure you want to leave?",
    activityQuestions: "Activity Questions",
    loadingQuestions: "Loading customer questions...",
    refreshingQuestions: "Refreshing...",
    noActivityQuestions: "No customer questions yet",
    questionLoadFailed: "Failed to load questions. Click refresh to retry.",
    questionImage: "Question image",
    questionFile: "Question attachment"
  },
  button: {
    copyMeetingLink: 'Copy Meeting Link',
    retryAudio: 'Restore Audio',
    enableAudio: 'Enable Audio',
    stopScreen: 'Stop sharing',
    retry: 'Retry after {count}s',
    handsUp: 'Hands up',
    leave: 'Leave',
    submit: 'submit',
    feedbackSubmit: 'Submit',
    warning: 'warning',
    confirm: 'confirm',
    cancel: 'cancel',
    micPhone: 'Select Microphone',
    screen: 'Share Screen',
    mute: 'Mute',
    unmute: 'Unmute',
    switchLang: '中文',
    malfunction: 'No equipment',
    checkout: 'sign out',
    moderator: 'Obtain host privileges',
    email_login: "Email Login",
    mobile_login: "Mobile Phone Login",
    tips: 'Tips',
    end: 'End',
    rescheduleMeeting: 'Reschedule',
    restartMeeting: 'Restart Meeting',
    refresh: 'Refresh',
    retryRecording: 'Retry Recording'
  },
  network: {
    type1: 'Network normal',
    type2: 'Network latency',
    type3: 'Severe network latency',
    delay: 'delay'
  }
}
